import { Editor } from 'slate';
import { isLink, isUrl } from '../helpers';
import { wrapLink } from '../transformers';

// Custom plugin to facilitate links in Slate editor
export const withLinks = (editor: Editor): Editor => {
	const { insertData, insertText, isInline } = editor;

	// Links are inline
	editor.isInline = (element) => isLink(element) || isInline(element);

	// Wrap text with link when inserting text/data
	editor.insertText = (text) =>
		isUrl(text) ? wrapLink(editor, text) : insertText(text);

	editor.insertData = (data) => {
		const text = data.getData('text/plain');
		isUrl(text) ? wrapLink(editor, text) : insertData(data);
	};

	return editor;
};
